import React, { useState } from 'react';
import { Input, Button, VStack, Text } from '@chakra-ui/react';

const EditPollForm = ({ poll, onSave, onCancel }) => {
  const [title, setTitle] = useState(poll.title);
  const [description, setDescription] = useState(poll.description);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!title.trim()) newErrors.title = 'Title is required';
    if (title.trim().length < 3) newErrors.title = 'Title must be at least 3 characters';
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    onSave({ title, description });
  };

  return (
    <form onSubmit={handleSubmit}>
      <VStack spacing={3} align="stretch">
        <Input
          type="text"
          value={title}
          onChange={e => {
            setTitle(e.target.value);
            setErrors(prev => ({ ...prev, title: undefined }));
          }}
          placeholder="Poll Title"
          isInvalid={!!errors.title}
        />
        {errors.title && <Text fontSize="sm" color="red.500">{errors.title}</Text>}

        <Input
          type="text"
          value={description}
          onChange={e => setDescription(e.target.value)}
          placeholder="Poll Description"
        />

        <div>
          <Button type="submit" colorScheme="teal" size="sm" mr={2}>
            Update Poll
          </Button>
          <Button onClick={onCancel} size="sm">
            Cancel
          </Button>
        </div>
      </VStack>
    </form>
  );
};

export default EditPollForm;
